import {
  GETVOUCHERMAPPINGLIST_SUCCESS,
  GETVOUCHERMAPPINGLIST_FAILED,
  RESET_GETVOUCHERMAPPINGLIST,
  LOADING_GETVOUCHERMAPPINGLIST,
  NETWORK_ERROR_GETVOUCHERMAPPINGLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetVoucherMappingList = () => {
  return { type: RESET_GETVOUCHERMAPPINGLIST };
};

const getVoucherMappingList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETVOUCHERMAPPINGLIST });
  await partnerServices
    .post("getVoucherMappingList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(getVoucherMappingListsuccess(res.data));
          break;
        default:
          dispatch(getVoucherMappingListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETVOUCHERMAPPINGLIST,
        payload: err,
      });
    });
};
function getVoucherMappingListsuccess(data) {
  return {
    type: GETVOUCHERMAPPINGLIST_SUCCESS,
    payload: data,
  };
}
function getVoucherMappingListFailed(data) {
  return {
    type: GETVOUCHERMAPPINGLIST_FAILED,
    payload: data,
  };
}

export { resetGetVoucherMappingList, getVoucherMappingList };
